import { Avatar } from '@mui/material';
import React from 'react';

export interface UserAvatarProps {
  firstName?: string;
  lastName?: string;
  username?: string;
  avatarColor?: string;
  size?: number;
  fontSize?: string;
}

const getContrastColor = (hexColor: string): string => {
  const hex = hexColor.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16) / 255;
  const g = parseInt(hex.substring(2, 4), 16) / 255;
  const b = parseInt(hex.substring(4, 6), 16) / 255;
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return luminance > 0.85 ? '#000000' : '#FFFFFF';
};

export const UserAvatar: React.FC<UserAvatarProps> = ({
  firstName,
  lastName,
  username,
  avatarColor = '#3B6FD9',
  size = 32,
  fontSize = '0.9375rem',
}) => {
  const getInitials = () => {
    if (username) {
      const words = username.match(/[A-Z][a-z]+/g) || [];
      if (words.length >= 2) {
        return (words[0]?.[0] || '') + (words[1]?.[0] || '');
      }
      return username.substring(0, 2).toUpperCase();
    }
    if (firstName && lastName) {
      return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
    }
    return 'U';
  };

  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        fontSize,
        fontWeight: 600,
        bgcolor: avatarColor,
        color: getContrastColor(avatarColor),
      }}
    >
      {getInitials()}
    </Avatar>
  );
};

export default UserAvatar;
